module.exports = __webpack_public_path__ + "img/menu.8319b4f0.png";